module.exports = __webpack_public_path__ + "img/ak女.b8db92d7.jpg";